import {Injectable} from '@angular/core';

/**
 * Service permettant de déterminer la classe css à appliquer selon le mode de l'application (cohabiation angular<->angularJs ou full angular)
 */
@Injectable({
	providedIn: 'root'
})
export class DeterminationModeApplicationService {

	/**
	 * @return true si on est sur une application en cohabiation angular<->angularJs. Une application est en cohabitation lorsque nous trouvons une directive "ng-controller"
	 */
	estModeApplicationCohabitationAngularJsAngular(): boolean {
		return document.querySelector('[ng-controller]') != null;
	}

	/**
	 * @return la classe css 'mode-cohabitation-angularjs-angular' si on est en cohabitation sinon 'mode-full-angular'
	 */
	determinerClasseCssModeApplication(): string {
		return this.estModeApplicationCohabitationAngularJsAngular() ? this.classeModeCohabitationAngularJsAngular() : this.classeModeFullAngular();
	}

	classeModeCohabitationAngularJsAngular() {
		return 'mode-cohabitation-angularjs-angular';
	}

	classeModeFullAngular() {
		return 'mode-full-angular';
	}
}